import { SiteFileStructure } from './siteFileStructure.js';
import { SiteFileSystem } from './siteFileSystem.js';
import { buildPagesState } from './stateBuilder.js';
export const buildState = async (rootFolderPath, fileStructureType) => {
    const fileSystem = new SiteFileSystem(rootFolderPath);
    const fileStructure = new SiteFileStructure(fileStructureType);
    const pages = await buildPagesState(fileStructure, fileSystem);
    return {
        fileSystem,
        fileStructure,
        pages
    };
};
